import { useModal } from '@trinity/chat-components/components/Modal/index.js';
import { DeleteFolderPrompt } from '../Prompt.DeleteFolder';

export const useDeleteFolderPrompt = () => {
  return useModal(DeleteFolderPrompt);
};